<!--
 * @Author: 邱扬
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-09-15 13:19:30
 * @LastEditTime: 2022-01-20 20:48:08
-->
<template>
  <van-overlay :show="show" class="common-loading" :style="{top:top+'px',bottom:bottom+'px'}">
    <div class="wrapper">
      <div class="block">
        <van-loading color="#1989fa" class="loading" />
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    top:{
      type:Number,
      default:50
    },
    bottom:{
      type:Number,
      default:55
    }
  },
  setup() {
    return {
    }
  },
}
</script>

<style scoped lang="scss">
.common-loading {
  background: #fff;
  opacity: 0.9;
  height: auto;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .block {
      width: 120px;
      height: 120px;

      .loading {
        position: relative;
        top: 50%;
        text-align: center;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
